import React, { Component } from 'react';
import './App.css';
import Intro from './Intro'
import IntroSelect from './IntroSelect'
import HomeScreen from './HomeScreen'
import VotingCalendar from './VotingCalendar'
import ElectionTypes from './ElectionTypes'
import HowVotesCounted from './HowVotesCounted'
import CompareCountry from './CompareCountry'
import Footer from './Footer'

class App extends Component {
  constructor(props) {
    super(props);
        this.state = {
          value:'Nigeria'
        }
      }

  render() {
    
    return (
      <div>
        <HomeScreen/>
        {/* animate this */}
        <Intro/>
        <VotingCalendar/>
        <br/>
        <IntroSelect/>
        <hr/>
        {/* <ElectionTypes/> */}
        {/* <hr/> */}
        <HowVotesCounted/>
        {/* <CompareCountry/> */}
        <Footer/>
      </div>
    );
  }
}

export default App;
